import { tv, type VariantProps } from 'tailwind-variants';
export type AtTagVariants = VariantProps<typeof atTextVariants>;

const atTextVariants = tv({
  base: 'text-skin-primary',
  slots: {},
  variants: {
    elementType: {
      p: '',
      label: '',
      span: '',
    },
    size: {
      xs: '',
      sm: '',
      md: '',
      lg: '',
    },
    variant: {
      default: '',
      disclaimer: 'disclaimer-text',
      stat: 'stat-text-basic uppercase',
      label: 'label-text uppercase',
    },
  },
  compoundVariants: [
    {
      size: 'xs',
      variant: 'default',
      className: 'paragraph-xs',
    },
    {
      size: 'sm',
      variant: 'default',
      className: 'paragraph-sm',
    },
    {
      size: 'md',
      variant: 'default',
      className: 'paragraph-md',
    },
    {
      size: 'lg',
      variant: 'default',
      className: 'paragraph-lg',
    },
  ],
});

export default atTextVariants;
